import React, { useState, useEffect } from "react";
import {
  f7,
  Page,
  Icon,
  Navbar,
  Popup,
  Button,
  Link,
  Input,
  Swiper as SwiperComponent,
  SwiperSlide,
  Tab,
  Tabs,
  Toolbar,
  Block,
  Preloader,
} from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH, IMG_URL } from "./../globals";
import { useCallback } from "react";
import debounce from "lodash.debounce";
import "./DatePicker.css";

const RestaurantDetailPage = ({ f7route }) => {
  const { id } = f7route.params;
  const [restdata, setRestDetails] = useState([]);
  const [restmenu, setRestMenu] = useState([]);
  const [count, setCount] = useState(1);
  const [cart, setCart] = useState([]);
  const [menuAmount, setMenuAmount] = useState(0);
  const [menuSizeId, setMenuSizeId] = useState(0);
  const [menuSizeName, setMenuSizeName] = useState({});
  const [totalAmount, setTotalAmount] = useState(0);
  const [cartItemQty, setCartItemQty] = useState(0);
  const [cartItemAmount, setCartItemAmount] = useState(0);
  const [cartRestId, setCartRestId] = useState(0);
  const [dietary, setDietary] = useState([]);
  const [chkValue, setChkValue] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [menuSize, setMenuSize] = useState(0);
  const [menuServes, setMenuServes] = useState("");

  var amount = menuAmount;
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  // const [isTokenAvailable, setIsTokenAvailable] = useState();
  const [auth, setAuth] = useState(localStorage.getItem("auth"));

  const [searchValue, setSearchValue] = useState("");

  // Function to handle API errors
  const handleApiError = (error) => {
    console.error(error);
    setIsError(true);
    setIsLoading(false);
  };

  const handleTabClick = (dietaryId) => {
    setActiveTab(dietaryId);
    // setSearchValue("");
    axios
      .get(API_BASE_URL + "menubyrest/id/" + id, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          menu_type_id: dietaryId,
          search: searchValue,
        },
      })
      .then((response) => {
        setRestMenu(response.data.data);
        // fetchMenuItems(dietaryId, searchValue);
      })
      .catch((error) => {
        console.log(error);
        setRestMenu([]);
      });
  };
  const fetchMenuItems = (dietaryId, searchValue) => {
    axios
      .get(`${API_BASE_URL}menubyrest/id/${id}`, {
        headers: {
          Authorization: `Basic ${API_AUTH}`,
        },
        params: {
          menu_type_id: dietaryId,
          search: searchValue,
        },
      })
      .then((response) => {
        setRestMenu(response.data.data);
      })
      .catch((error) => {
        console.log(error);
        setRestMenu([]);
      });
  };

  // const searchByDishes = (dietaryId, ) => {
  //   axios
  //     .get(`${API_BASE_URL}menubyrest/id/${id}`, {
  //       headers: {
  //         Authorization: `Basic ${API_AUTH}`,
  //       },
  //       params: {
  //         menu_type_id: dietaryId,
  //       },
  //     })
  //     .then((response) => {
  //       setRestMenu(response.data.data);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setRestMenu([]);
  //     });
  // };

  const debouncedSearch = useCallback(
    debounce((value) => {
      fetchMenuItems(activeTab, value);
    }, 500),
    [activeTab]
  );

  const handleChange = (event) => {
    event.preventDefault();
    const { value } = event.target;
    setSearchValue(value);
    debouncedSearch(value);
  };
  // useEffect(() => {
  //   // Initial fetch or when the component mounts
  //   fetchMenuItems(activeTab, searchValue);
  // }, [activeTab,]);
  const MenuAmount = (amt, menu_size_id, size_name, menu_size, serves) => {
    setMenuAmount(amt);
    setTotalAmount(amt);
    setCount(1);
    setMenuSizeId(menu_size_id);
    setMenuSizeName(size_name);
    setChkValue(menu_size_id);
    setMenuSize(menu_size);
    setMenuServes(serves);
  };
  const handleIncrement = () => {
    // if (count < 20) {
    setCount(count + 1);
    setTotalAmount(amount * (count + 1));
    // }
  };

  const handleDecrement = () => {
    if (count > 0) {
      setCount(count - 1);
      setTotalAmount(amount * (count - 1));
    }
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;

    // Ensure the input is a valid number
    if (!isNaN(newValue) && Number(newValue) >= 0) {
      setCount(Number(newValue));
      setTotalAmount(amount * Number(newValue));
    }
  };

  const updateCart = (newCart) => {
    setCart(newCart);
    const storedData =
      JSON.parse(localStorage?.getItem("orderCartItems")) || [];
    const orderCartItemsDetails = { ...storedData, items: newCart };
    localStorage.setItem(
      "orderCartItems",
      JSON.stringify(orderCartItemsDetails)
    );
    const cart =
      JSON.parse(localStorage?.getItem("orderCartItems"))?.items || [];

    // Calculate the total quantity of items
    var qty = cart.length;

    // Calculate the total amount of all cart items
    const total = cart.reduce(
      (accumulator, currentValue) => accumulator + currentValue?.total_amount,
      0
    );

    // Update the state with cart quantity and total amount
    setCartItemQty(qty);
    setCartItemAmount(total);
  };
  const addMenuToCart = (menu_id) => {
    let cart = JSON.parse(localStorage?.getItem("orderCartItems"))?.items || [];
    if (count > 0 && menuSizeId > 0 && menuSizeName && menuAmount > 0) {
      const cartItem = {
        menu_id: menu_id,
        menu_size_id: menuSizeId,
        menu_size_name: menuSizeName,
        qty: count,
        menu_amount: menuAmount,
        total_amount: totalAmount,
        menu_name: data.map((item) => item.menu_item_name)[0],
        menu_item_picture: data.map((item) => item.menu_item_picture)[0],
        rest_id: cartRestId,
        menu_size: menuSize,
        serves: menuServes,
      };
      // const cart = JSON.parse(localStorage.getItem("cartItems")) || [];
      // const updatedCart = [...cart, cartItem];
      if (!Array.isArray(cart)) {
        cart = [];
      }
      const isRestIdMatched = cart?.some((item) => item?.rest_id == cartRestId);
      if (isRestIdMatched) {
        const updatedCart = [...cart, cartItem];
        updateCart(updatedCart);
      } else {
        // localStorage.removeItem("cartItems");
        // cart = [];
        const updatedCart = [cartItem];
        updateCart(updatedCart);
      }
      f7.popup.close(".add-product");
    } else {
      f7.toast
        .create({
          text: "Please select Menu Size...",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
    }
  };
  // const handleChange = (e) => {
  //   // const numericValue = e.target.value.replace(/[^\d.]/g, "");
  //   setSearchValue(e.target.value);
  // };

  useEffect(() => {
    const id = localStorage.getItem("id");
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: "Basic " + API_AUTH,
    };
    axios
      .post(API_BASE_URL + "custauth", { id, token }, { headers })
      .then((response) => {
        // console.log("response.data.test");
        if (response.data.status === "success") {
          localStorage.setItem("auth", true);
          setAuth(true);
        } else {
          localStorage.setItem("auth", false);
          setAuth(false);
        }
      })
      .catch((error) => {
        setAuth(false);
      });
  });

  useEffect(() => {
    // localStorage.removeItem("cartItems");
    // setAuth(localStorage.getItem("auth"));

    axios
      .get(API_BASE_URL + "restaurantdetails/id/" + id, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        const cart =
          JSON.parse(localStorage.getItem("orderCartItems"))?.items || [];
        // const updatedCart = [...cart, cartItem];
        const isRestIdMatched =
          cart.length > 0 ? cart?.some((item) => item?.rest_id == id) : false;

        if (isRestIdMatched) {
          updateCart(cart);
        }
        setRestDetails(response?.data);
        setIsLoading(false);
      })
      .catch(handleApiError);

    axios
      .get(API_BASE_URL + "menutype", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          rest_id: id,
        },
      })
      .then((response) => {
        setDietary(response.data.data);
      })
      .catch(handleApiError);

    axios
      .get(API_BASE_URL + "menubyrest/id/" + id, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        setRestMenu(response.data.data);
      })
      .catch(handleApiError);
  }, [id]);

  // console.log(restdata);

  const [data, setData] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    if (isPopupOpen) {
      console.log(1);

      // const addmenuitem = localStorage.getItem('addmenuitem');
      // axios.get(API_BASE_URL + 'menubyrest/id/'+ id, {
      //   headers: {
      //     'Authorization': 'Basic ' + API_AUTH
      //   },
      //   params:{
      //     'menu_id': addmenuitem
      //   }
      // })
      // .then(response => {setData(response.data.data)})
      // .catch(error => console.log(error));
      // localStorage.removeItem('addmenuitem');
    }
  }, [isPopupOpen, id]);

  const handlePopupOpen = (menuid) => {
    if (auth) {
      setIsPopupOpen(true);
      f7.popup.open(".add-product");
      // localStorage.setItem('addmenuitem', menuid);
      // const addmenuitem = localStorage.getItem('addmenuitem');
      axios
        .get(API_BASE_URL + "menubyrest/id/" + id, {
          headers: {
            Authorization: "Basic " + API_AUTH,
          },
          params: {
            menu_id: menuid,
          },
        })
        .then((response) => {
          setData(response.data.data);
          setCartRestId(response.data.data[0].rest_id);
          setCount(0);
          setMenuAmount(0);
          setTotalAmount(0);
          setChkValue(0);
        })
        .catch((error) => console.log(error));
    } else {
      f7.views.main.router.navigate("/login/");
    }
    // localStorage.removeItem('addmenuitem');
  };

  const handlePopupClose = () => {
    setIsPopupOpen(false);
    f7.popup.close(".add-product");
  };

  return (
    <Page className="bg-white">
      <div className="container container-table">
        <div className="row vertical-center-row col col-md-offset-12">
          {isLoading ? (
            <section className="mt-3">
              <div className="custom-container p-0">
                <div className="text-center mt-5">
                  <Preloader color="orange" />
                </div>
              </div>
            </section>
          ) : isError ? (
            <div className="error-indicator">Error fetching data.</div>
          ) : (
            <div className="header-custom1 p-0">
              {restdata.map((restdetail) => (
                <div>
                  {restdetail.rest_img !== null ? (
                    <div
                      className="header-panel-lg"
                      style={{
                        backgroundImage: `url(${IMG_URL}${restdetail.rest_img})`,
                      }}
                    >
                      <Navbar
                        backLink="Back"
                        transparent
                        style={{ zIndex: "1999" }}
                      />
                    </div>
                  ) : (
                    <div
                      className="header-panel-lg"
                      style={{
                        backgroundImage: `url(https://www.eatbids.com/img/apps/no-image.png)`,
                        backgroundSize: "cover",
                        backgroundPosition: "center center", // Replace with your image URL
                      }}
                    >
                      {/* <img className="img-fluid img" src={require("./../images/noimage.jpg")} alt={restdetail.rest_name} style={{ height: '120px', width:'100%'}}/> */}
                      <Navbar
                        backLink="Back"
                        transparent
                        style={{ zIndex: "1999" }}
                      />
                    </div>
                  )}
                </div>
              ))}

              <section>
                <div className="custom-container p-2">
                  {restdata.map((restdetail) => (
                    <div className="restaurant-details-box">
                      <div className="restaurant-head">
                        <div className="name">
                          <img
                            className="img-fluid restaurant-logo"
                            src="https://cdn-icons-png.flaticon.com/128/3170/3170733.png"
                            alt="starbucks-logo"
                          />
                          <div className="d-block ms-2">
                            <h3>{restdetail.rest_name}</h3>
                            <h6>{restdetail.cuisine_name}</h6>
                          </div>
                        </div>
                        <div className="option">
                          <a href="#">
                            <i className="ri-share-line share" />
                          </a>
                          <a href="#">
                            <i className="toggle-heart ri-heart-3-fill heart" />
                          </a>
                        </div>
                      </div>
                      <div className="restaurant-details">
                        <div className="location">
                          <h6 className="pt-2 light-text">
                            {restdetail.add_lin_1} {restdetail.add_lin_2}{" "}
                            {restdetail.city} {restdetail.state}{" "}
                            {restdetail.zip_code}
                          </h6>
                        </div>
                        {/* <ul className="distance">
                      <li><i className="ri-map-pin-fill theme-color" /> 1 km</li>
                      <li><i className="ri-time-fill theme-color" /> 15 min</li>
                    </ul> */}
                      </div>
                    </div>
                  ))}
                </div>
              </section>

              <section className="food-filter mt-0 mb-0 p-3">
                <div
                  className="custom-container p-0 swiper-container-div mb-0"
                  style={{ marginTop: "-15px" }}
                >
                  <div className="swiper-container">
                    <ul className="food-symbol swiper-wrapper">
                      <li className="swiper-slide-menu-type">
                        <Link
                          tabLink="#tab-1"
                          className={`food-types ${
                            activeTab === 0 ? "active" : ""
                          }`}
                          onClick={() => handleTabClick(0)}
                        >
                          <h5 className="text-dark">All</h5>
                          <i className="ri-close-line close" />
                        </Link>
                      </li>
                      {dietary.map((element) => (
                        <li className="swiper-slide-menu-type">
                          <Link
                            tabLink="#tab-2"
                            className={`food-types ${
                              activeTab === element.id ? "active" : ""
                            }`}
                            onClick={() => handleTabClick(element.id)}
                          >
                            <h5 className="text-capitalize text-dark">
                              {element.name}
                            </h5>
                            <i className="ri-close-line close" />
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </section>
              <div
                style={{
                  marginLeft: "15px",
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                  position: "relative",
                }}
              >
                <input
                  style={{
                    width: "325px",
                    border: "1px solid lightgrey",
                    padding: "5px 10px 5px 35px", // extra padding to make space for the icon
                    borderRadius: "4px",
                    position: "relative",
                  }}
                  placeholder="Search..."
                  value={searchValue}
                  onChange={handleChange}
                />
                <Icon
                  ios="material:search"
                  aurora="material:search"
                  md="material:search"
                  size={20}
                  style={{
                    position: "absolute",
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    color: "grey",
                  }}
                />
              </div>
              <section className="food-list-section section-b-space mt-0">
                <div className="custom-container p-3 mt-0">
                  <div className="list-box" style={{ marginTop: "-70px" }}>
                    <div
                      className="accordion food-accordion"
                      id="accordionPanelsStayOpenaccordion1"
                    >
                      <div className="accordion-item">
                        <div
                          id="panelsStayOpen-collapseOne"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample "
                        >
                          <div className="accordion-body">
                            <div>
                              {/* {restdetail.rest_name} */}

                              {restmenu.length > 0 ? (
                                restmenu.map((menu) => (
                                  <div className="product-box2 mt-4">
                                    <div className="product-content">
                                      {/* <img className="img" src="https://themes.pixelstrap.com/zomo-app/assets/images/svg/nonveg.svg" alt="non-veg" /> */}
                                      <h5 className="product-name text-capitalize text-dark">
                                        {menu.menu_item_name}
                                      </h5>
                                      <div className="product-price">
                                        <h6 className="fw-semibold text-dark text-4">
                                          <span className="text-warning text-1">
                                            Start @
                                          </span>{" "}
                                          ${" "}
                                          {parseFloat(
                                            menu.menu_item_price
                                          ).toFixed(2)}
                                        </h6>
                                      </div>
                                      <p className="mb-0 mt-2 pt-2">
                                        {menu.menu_item_desc}
                                      </p>
                                    </div>
                                    <div className="product-img">
                                      <a
                                        href="#product-popup"
                                        data-bs-toggle="offcanvas"
                                      >
                                        {menu.menu_item_picture !== null &&
                                        menu.menu_item_picture !== "" ? (
                                          <img
                                            className="img-fluid img"
                                            style={{
                                              height: "125px",
                                              width: "125px",
                                            }}
                                            src={`${IMG_URL}${menu.menu_item_picture}`}
                                            alt={menu.menu_item_name}
                                          />
                                        ) : (
                                          <img
                                            className="img-fluid img"
                                            style={{
                                              height: "125px",
                                              width: "125px",
                                            }}
                                            src={require("./../images/no-image.png")}
                                            alt={menu.menu_item_name}
                                          />
                                        )}
                                      </a>
                                      <div className="add-btn">
                                        <Button
                                          fill
                                          className="btn btn-outline-success bg-white pt-2 text-success mt-0 text-2 fw-bold"
                                          onClick={() =>
                                            handlePopupOpen(menu.menu_item_id)
                                          }
                                        >
                                          {" "}
                                          + ADD{" "}
                                        </Button>
                                      </div>
                                      <div className="plus-minus">
                                        <i className="ri-subtract-line sub" />
                                        <input
                                          type="number"
                                          defaultValue={1}
                                          min={1}
                                          max={10}
                                        />
                                        <i className="ri-add-line add" />
                                      </div>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className="custom-container">
                                  <div className="empty-tab">
                                    <h2>No Menu Found!!</h2>
                                    <h5 className="mt-3">
                                      You have currently no menus.
                                    </h5>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <div className="cart-popup">
                <div className="price-items">
                  <h3>
                    $
                    {cartItemAmount > 0
                      ? parseFloat(cartItemAmount).toFixed(2)
                      : 0}
                  </h3>
                  <h6>{cartItemQty > 0 ? cartItemQty : 0} item Added</h6>
                </div>
                <a
                  href={
                    auth
                      ? `/cart/${restdata.map((item) => item.rest_id)}`
                      : "/login/"
                  }
                  class="btn theme-btn cart-btn mt-0"
                >
                  View Cart
                </a>
              </div>
            </div>
          )}

          <Popup className="add-product custom-web ">
            <Page>
              <div className="search-filter modal-dialog modal-fullscreen custom-web">
                <div className="modal-content">
                  <header className="section-t-space">
                    <div className="container-lg custom-container p-0">
                      <div className="header-panel">
                        <Link />
                        <h2>Add Menu</h2>
                        <Link
                          className="btn-close"
                          popupClose
                          style={{ marginRight: "15px" }}
                        />
                      </div>
                    </div>
                  </header>
                  {data.map((item) => (
                    <section className="section-b-space">
                      <div className="custom-container mt-5">
                        <div className="horizontal-product-box">
                          <div className="product-img">
                            {/* <img className="img-fluid img" src={`${IMG_URL}${item.menu_item_picture}`} alt={item.menu_item_name} /> */}

                            {item.menu_item_picture !== null &&
                            item.menu_item_picture !== "" ? (
                              <img
                                className="img-fluid img"
                                style={{ height: "78px", width: "78px" }}
                                src={`${IMG_URL}${item.menu_item_picture}`}
                                alt={item.menu_item_name}
                              />
                            ) : (
                              <img
                                className="img-fluid img"
                                style={{ height: "78px", width: "78px" }}
                                src={require("./../images/no-image.png")}
                                alt={item.menu_item_name}
                              />
                            )}
                          </div>
                          <div className="product-content">
                            <h5>{item.menu_item_name}</h5>
                            <h6>{item.menu_item_desc}</h6>
                            {/* <Stepper raised/> */}
                            <div
                              className="plus-minus p-0"
                              style={{
                                color: "black", // Text color
                                border: "1px solid #F5F5F5", // Border style
                              }}
                            >
                              <i className="ri-subtract-line sub" />
                              <Button onClick={handleDecrement}>
                                <Icon
                                  ios="material:remove"
                                  aurora="material:remove"
                                  md="material:remove"
                                  size={14}
                                  style={{
                                    color: "black", // Text color
                                  }}
                                ></Icon>
                              </Button>

                              <Input
                                type="text"
                                value={count}
                                min={1}
                                onChange={(e) => handleInputChange(e)} // Add this line
                              />
                              <Button onClick={handleIncrement}>
                                <Icon
                                  ios="material:add"
                                  aurora="material:add"
                                  md="material:add"
                                  size={14}
                                  style={{
                                    color: "black", // Text color
                                  }}
                                ></Icon>
                              </Button>
                              <i className="ri-add-line add" />
                            </div>
                            {/* <h3 className="product-price text-dark">$ {menuAmount}</h3> */}
                          </div>
                        </div>

                        <section className="pt-0">
                          <div className="order-options">
                            <h3 className="mt-3 mb-3 dark-text fw-bold">
                              Choose Size
                            </h3>
                            {item.menu_size.map((size, index) => (
                              <div className="order-type">
                                <div className="auth-form search-form">
                                  <div className="form-check">
                                    <label
                                      className="form-check-label"
                                      htmlFor="fixed1"
                                    >
                                      {size.name} ({size.menu_size}) - ${" "}
                                      {parseFloat(size.menu_amount).toFixed(2)}
                                    </label>
                                    <input
                                      className="form-check-input size_chk_box"
                                      value={size.menu_size_id}
                                      checked={chkValue === size.id}
                                      onClick={(e) =>
                                        MenuAmount(
                                          size.menu_amount,
                                          size.id,
                                          size.name,
                                          size.menu_size_id,
                                          size.menu_size
                                        )
                                      }
                                      type="radio"
                                      name="flexRadioDefault"
                                      id=""
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </section>
                        <div
                          className="body-title d-flex justify-content-between section-t-space section-b-space profile-form"
                          style={{ marginTop: "-50px" }}
                        >
                          <h3 className="fw-semibold dark-text d-flex align-items-center fw-bold">
                            Total
                          </h3>
                          <h2 className="text-success">
                            ${" "}
                            {totalAmount > 0
                              ? parseFloat(totalAmount).toFixed(2)
                              : 0}
                          </h2>
                        </div>
                        <div
                          className="filter-footer profile-form"
                          style={{ marginTop: "-75px" }}
                        >
                          <a
                            href="#"
                            className="btn theme-btn apply-btn w-100"
                            onClick={(e) => addMenuToCart(item.menu_id)}
                            data-bs-dismiss="modal"
                            data-bs-toggle="offcanvas"
                          >
                            Add To Cart
                          </a>
                        </div>
                      </div>
                    </section>
                  ))}
                </div>
              </div>
            </Page>
          </Popup>
        </div>
      </div>
    </Page>
  );
};
export default RestaurantDetailPage;
